import { longClickDirective } from 'vue-long-click'


export default async ({ Vue }) => {
  const longClickInstance = longClickDirective({delay: 400, interval: 50})
  Vue.directive('longclick', longClickInstance)
}
